// Generated by Melange

import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_dictapis__Buhta_dict_v1alpha1_kogd_service from "../../../../proto/dictapis/gen/buhta_dict_v1alpha1_kogd_service.js";
import * as Curry from "melange.js/curry.js";

const Kogd = {};

const apiEndpointPrefix = "/dict";

function grid(tenant, params, language, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.codes;
  }), Buhta_core__Grpc.makeRpc(undefined, Curry._2(Buhta_dictapis__Buhta_dict_v1alpha1_kogd_service.Buhta.Dict.V1alpha1.ListOgdCodesRequest.make, undefined, undefined), Buhta_dictapis__Buhta_dict_v1alpha1_kogd_service.Buhta.Dict.V1alpha1.KogdService.listOgdCodes, undefined, undefined, undefined, apiEndpointPrefix + Buhta_dictapis__Buhta_dict_v1alpha1_kogd_service.Buhta.Dict.V1alpha1.KogdService.ListOgdCodes.name, language, undefined));
}

const KogdService = {
  grid: grid
};

const $$default = {
  code: "",
  parent: undefined,
  name: "",
  keywords: "",
  tin: "",
  contact_phone: undefined,
  effective_from: undefined,
  effective_until: undefined
};

export {
  Kogd,
  $$default as default,
  apiEndpointPrefix,
  KogdService,
}
/* Buhta_core__Grpc Not a pure module */
